import { ReactNode } from 'react';
import styled from 'styled-components';

import { LinkButton } from 'components/Toolkit/Button/LinkButton';
import { media } from 'helpers/breakpoints';
import { useDealerFilterDispatch } from 'components/DealerPage/context/DealerFilterContext';
import { LastSearchCard } from 'components/PageWrappers/SharedComponents/LastSearchCard/LastSearchCard';
import type { TLastSearch } from 'components/PageWrappers/SharedComponents/LastSearchCard/types';
import { Spacer } from 'helpers/genericStyles';

export interface IFiltersPanelProps {
  children: ReactNode;
  lastSearchData?: TLastSearch;
  lastSearchCallback?: () => void;
  showSearch?: boolean;
}

const Header = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.S8};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};

  ${media.large} {
    display: flex;
    justify-content: space-between;
    padding-bottom: ${({ theme }) => theme.spacing.M16};
  }
`;

const Heading = styled.h5`
  ${({ theme }) => theme.fontSize.L24};
`;

const Body = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.L48};
`;

function FiltersPanel({
  children,
  lastSearchData,
  lastSearchCallback,
  showSearch = true,
}: IFiltersPanelProps) {
  const { reset } = useDealerFilterDispatch();
  return (
    <div>
      <Header>
        <Heading>Filters</Heading>
        <LinkButton onClick={reset}>Reset All</LinkButton>
      </Header>
      {showSearch && (
        <>
          <LastSearchCard
            lastSearchData={lastSearchData}
            lastSearchCallback={lastSearchCallback}
            lastSearchDataTrackingValue="last_search_search_page"
          />
          <Spacer marginBottom={['M16']} />
        </>
      )}
      <Body>{children}</Body>
    </div>
  );
}

export { FiltersPanel };
